<div class="col-xs-12 col-md-4 col-lg-3">
  <a
    [routerLink]="
      {
        cxRoute: backRoute,
        params: { code: orderCode }
      } | cxUrl
    "
    class="btn btn-block btn-action"
  >
    {{ 'common.back' | cxTranslate }}
  </a>
</div>
<div class="col-xs-12 col-md-4 col-lg-3">
  <button
    *ngIf="forwardRoute"
    class="btn btn-block btn-primary"
    (click)="continue($event)"
  >
    {{ 'common.continue' | cxTranslate }}
  </button>

  <button *ngIf="!forwardRoute" class="btn btn-block btn-primary" type="submit">
    {{ 'orderDetails.cancellationAndReturn.submit' | cxTranslate }}
  </button>
</div>
